import commonActions from '@/store/data/common/actions'
import { webRequestClient } from '@/services'
import { isEmpty, get, isNil } from 'lodash'
import helpers from './helpers'
import { errorHandler } from '@/utils/helpers'

const actions = {
    retrieveItems({ commit, dispatch, rootState }) {
        const _route = helpers.buildRoutes(rootState.account)
        commit('setIsLoading', true)
        return webRequestClient
            .get(_route.route, _route.params)
            .then(dsp => {
                if (get(dsp, 'status') === 'KO') {
                    errorHandler('Error while retrieving dsps', commit)
                    return null
                } else {
                    if (!isEmpty(dsp.list)) {
                        commit('setRetrievedItems', { items: helpers.parseData(dsp.list) })
                    }
                    return dsp
                }
            })
            .then(dsp => {
                // -- retrieve accountsDsps data after dsp data retrieval -- \\
                if (!isNil(dsp) && !isEmpty(dsp.list)) {
                    return dispatch('data/accountsDsps/retrieveItems', {}, { root: true })
                }
            })
            .catch(error => {
                errorHandler(error, commit)
            })
            .finally(() => {
                commit('setIsLoading', false)
            })
    }
}

export default { ...commonActions, ...actions }
